import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="text-foreground-950 font-heading font-bold text-3xl md:text-4xl leading-tight">
              热度榜单
              <br />
              今日必吃大瓜
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              基于实时阅读量、讨论热度和分享数据综合计算的每日吃瓜排行榜，热度越高代表越多人关注，榜首内容绝对不容错过。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-800 rounded-2xl p-5 md:p-6 lg:col-span-1">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#ranking"
                className="flex items-center gap-4 py-3 border-b border-background-700/50 last:border-b-0 cursor-pointer hover:bg-background-700/30 transition-colors -mx-2 px-2 rounded-lg"
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank === 1 ? 'bg-accent-500 text-foreground-950' :
                  item.rank === 2 ? 'bg-primary-500 text-white' :
                  item.rank === 3 ? 'bg-secondary-500 text-white' :
                  'bg-background-700 text-white/60'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-white text-sm font-medium leading-snug truncate">{item.title}</h3>
                </div>
                <span className="text-accent-400 text-xs font-semibold whitespace-nowrap flex-shrink-0">{item.heat}</span>
              </a>
            ))}
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {rankingItems.slice(0, 4).map((item) => (
              <a
                key={item.rank}
                href="#ranking"
                className="bg-background-50 rounded-xl p-4 md:p-5 hover:bg-background-200 transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-3 mb-2">
                  <span className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                    item.rank <= 3 ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </span>
                  <span className="text-accent-500 text-xs font-semibold">{item.heat}</span>
                </div>
                <h3 className="text-foreground-900 text-sm font-medium leading-snug">
                  {item.title}
                </h3>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}